import { lang } from '@umu/ukit-lang';
import { customFormatDateTime } from '@umu/umu-util';
import { $document } from '@umu/umu-dom';
import { getCharacterLength, openCourseInMp } from 'businessCommon/src/@utils';

export interface IPrames {
    width: number;
    unitWidth: number;
    hightlight: string;
}
export const TagRegExp = /<[^>]+>/g;
const replaceHighlight = (hightlight: string) => {
    hightlight = hightlight || '';
    return hightlight.replace(TagRegExp, '');
};
const MIN_LEN = 1;
const getWordNum = (hightlight: string) => {
    const mathPosArr: number[] = [];
    hightlight.replace(TagRegExp, (match: string, pos: number) => {
        if (match) {
            mathPosArr.push(pos);
        }
        return '';
    });
    const EM_TAG_LENGTH = 4;
    const firstHightlightPos = mathPosArr[0];
    const firstTagClosePos = mathPosArr[1];
    const sliceFirstHightText = hightlight.slice(0, firstHightlightPos);
    const sliceLastHightText = hightlight.slice(firstHightlightPos);
    const hightText = hightlight.slice(firstHightlightPos + EM_TAG_LENGTH, firstTagClosePos);
    const wordNum = getCharacterLength(hightlight);
    return { firstHightlightPos, wordNum, sliceFirstHightText, sliceLastHightText, hightText };
};
// 裁切字符
const ELLIPSIS_WORD_NUM = 3;
const getInterceptWord = (text: string, needWordNum: number) => {
    const num = needWordNum + ELLIPSIS_WORD_NUM;
    let interceptWord: string = text;
    let len = getCharacterLength(interceptWord);
    while (num < len) {
        interceptWord = interceptWord.slice(0, -1);
        len = getCharacterLength(interceptWord);
    }
    if (text.trim() === interceptWord.trim()) {
        interceptWord = '';
    }
    return interceptWord;
};
// 获取宽度 width 外层传入
// 单位宽度 unitWidth
// needWordNum = width / unitWidth
// 获取第一个高亮的位置 firstHightlightPos
// 计算首字符到高亮字符 wordNum
// wordNum - needWordNum > 0 需要裁多余字符，注意需要考虑三个点点字符
const computerHightlight = (prames: IPrames) => {
    const { width, unitWidth, hightlight } = prames;
    if (!TagRegExp.test(hightlight)) {
        return hightlight;
    }
    const needWordNum = Math.ceil(width / unitWidth);
    const { wordNum, sliceFirstHightText, sliceLastHightText } = getWordNum(hightlight);
    const gapNum = wordNum - needWordNum;
    if (gapNum > 0) {
        const interceptWord = getInterceptWord(sliceFirstHightText, needWordNum);
        return !!interceptWord ? `${interceptWord}...${sliceLastHightText}` : hightlight;
    }

    return hightlight;
};
const hidePanelByIdAndData = (id: string, count: number, show: boolean) => {
    if (!id) {
        return;
    }
    const iframe = $document.getElementById(id) as HTMLIFrameElement;
    if (!iframe) {
        return;
    }
    iframe.style.display = !show && count < MIN_LEN ? 'none' : '';
};
const gotoShareByUrl = (url: string, isOpen: boolean) => {
    if (url && url !== '') {
        if (!isOpen) {
            openCourseInMp({ url });
        }
    }
};
// 统计学习阶段卡片
const getProgramCardCount = (
    moduleNum: string,
    groupNum: string,
    sessionNum: string,
    openModule?: string,
): string[] => {
    moduleNum = moduleNum || '0';
    groupNum = groupNum || '0';
    sessionNum = sessionNum || '0';
    openModule = openModule || '1';
    // 4个学习阶段，14门课程
    // 4门课程，14个小节
    const moduleStr = lang('{$0{0=个学习阶段,1=个学习阶段}}', moduleNum);
    const groupStr = lang('{$0{0=门课程,1=门课程}}', groupNum);
    const sessionStr = lang('{$0{0=个小节,1=个小节}}', sessionNum);
    let list = [moduleStr, groupStr];
    if (openModule === '0') {
        list = [groupStr, sessionStr];
    }
    return list;
};

const timePerDay = 86400 * 1000;

const getDayPoint = (time: Date) => {
    time.setMinutes(0);
    time.setSeconds(0);
    time.setMilliseconds(0);
    time.setHours(0);
    const todayStart = time.getTime();
    return todayStart;
};
const transTime = (time: number) => {
    const check = getDayPoint(new Date());
    const hhmm = customFormatDateTime(time, ' hh:mm');
    const yymmdd = customFormatDateTime(time, 'yyyy-MM-dd hh:mm');
    const newyy = customFormatDateTime(check, 'yyyy');
    const yy = customFormatDateTime(time, 'yyyy');
    // 在今天之后
    if (time >= check) {
        if (time <= check + timePerDay) {
            return lang('今天') + hhmm; // 今天
        } else if (time <= check + timePerDay * 2) {
            return lang('明天') + hhmm; // 明天
        } else if (time <= check + timePerDay * 3) {
            return lang('后天') + hhmm; // 后天
        } else if (time <= check + timePerDay * 7) {
            const days = Math.ceil((time - check) / timePerDay);
            return lang('{$0{0=天后 ,1=天后 }}', days) + customFormatDateTime(time, ' hh:mm');
        } else {
            return '' + yymmdd; //
        }
        // 在今天之前
    } else if (time < check) {
        if (time >= check - timePerDay) {
            return lang('昨天') + hhmm; // 昨天
        } else if (time >= check - timePerDay * 2) {
            return lang('前天') + hhmm; // 前天
        } else if (time >= check - timePerDay * 7) {
            const days = Math.ceil((check - time) / timePerDay);
            return lang('{$0{0=天前 ,1=天前 }}', days) + customFormatDateTime(time, ' hh:mm');
        } else {
            if (yy === newyy) {
                return customFormatDateTime(time, 'MM-dd hh:mm');
            }
            return '' + yymmdd;
        }
    }

    return '';
};

export {
    hidePanelByIdAndData,
    getProgramCardCount,
    computerHightlight,
    replaceHighlight,
    gotoShareByUrl,
    getDayPoint,
    transTime,
};
